var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import legacyBackground from '../../assets/images/bridge/backgrounds/legacy.png';
import premiumBackground from '../../assets/images/bridge/backgrounds/premium.png';
import standardBackground from '../../assets/images/bridge/backgrounds/standard.png';
import { LoadingContext } from '../../context/loading';
import { appEnv } from '../../env';
export function useOpenSea() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useState([
        {
            key: 'arkhante-booster-standard-pack',
            label: t('pack.standard'),
            background: standardBackground,
            path: 'https://opensea.io/collection/arkhante-booster-standard-pack',
            floorPrice: undefined,
        },
        {
            key: 'cross-the-ages-arkhante-booster-premium-pack-1',
            label: t('pack.premium'),
            background: premiumBackground,
            path: 'https://opensea.io/collection/cross-the-ages-arkhante-booster-premium-pack-1',
            floorPrice: undefined,
        },
        {
            key: 'arkhante-booster-premium-pack',
            label: t('pack.legacy'),
            background: legacyBackground,
            path: 'https://opensea.io/collection/arkhante-booster-premium-pack',
            floorPrice: undefined,
        },
    ]), items = _a[0], setItems = _a[1];
    useEffect(function () {
        function fetchPrice() {
            return __awaiter(this, void 0, void 0, function () {
                var newItems, _i, newItems_1, item, floorPrice;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setServerLoading(true);
                            newItems = __spreadArray([], items, true);
                            _i = 0, newItems_1 = newItems;
                            _a.label = 1;
                        case 1:
                            if (!(_i < newItems_1.length)) return [3 /*break*/, 4];
                            item = newItems_1[_i];
                            return [4 /*yield*/, getItemFloorPrice(item.key)];
                        case 2:
                            floorPrice = _a.sent();
                            item.floorPrice = floorPrice;
                            _a.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            setItems(newItems);
                            setServerLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchPrice();
    }, []);
    function getItemFloorPrice(key) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, data, asset;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "https://api.opensea.io/api/v2/collections/".concat(key, "/stats");
                        return [4 /*yield*/, fetch(url, {
                                headers: {
                                    Accept: 'application/json',
                                    'x-api-key': appEnv.openSeaApiKey,
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _b.sent();
                        asset = (_a = data === null || data === void 0 ? void 0 : data.total) === null || _a === void 0 ? void 0 : _a.floor_price;
                        return [2 /*return*/, asset
                            // return asset ? asset.sell_orders[0].current_price / 1e18 : undefined
                        ];
                }
            });
        });
    }
    return { items: items };
}
